export default function loader() {
  const requireModules = require.context("@modules/", true, /^\.\/.*\/store\/.*\.js$/);
  // extract js files inside modules folder
  const modules = {};

  requireModules.keys().forEach((fileName) => {
    const requiredModule = requireModules(fileName);
    Object.keys(requiredModule).forEach((key) => {
      const module = requiredModule[key];
      const moduleName = key == "default" ? module.moduleName : key;
      modules[moduleName] = module;
    });
  });

  return modules;
}
